import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "shell" }

import{computed}from"vue";import{useRoute}from"vue-router";import GlobalHeader from"@/components/GlobalHeader.vue";import HeroField from"@/components/HeroField.vue";import{useOpinionScene}from"@/composables/useOpinionScene";
export default /*@__PURE__*/_defineComponent({
  __name: 'BasicLayout',
  setup(__props) {
const route=useRoute(),{progress,selection,burst,bursting}=useOpinionScene(),sceneVisible=computed(()=>route.path==="/"||route.path==="/space/create");
return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(GlobalHeader),
    _createElementVNode("div", {
      class: _normalizeClass(["shared-scene", { visible: sceneVisible.value, bursting: _unref(bursting) }]),
      "aria-hidden": "true"
    }, [
      _createVNode(HeroField, {
        progress: _unref(progress),
        selection: _unref(selection),
        burst: _unref(burst),
        bursting: _unref(bursting),
        interactive: false
      }, null, 8, ["progress", "selection", "burst", "bursting"])
    ], 2),
    _createElementVNode("main", null, [
      _createVNode(_component_router_view, null, {
        default: _withCtx(({ Component }) => [
          _createVNode(_Transition, { name: "scene" }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})